<div class="row shadow" *ngIf="!isNew">
    <div class="fa fas fa-close pt-2 cursor-pointer" style="text-align: end;" (click)="closeContainer()"></div>
    <app-content-detail [contentId]="contentId" *ngIf="contentId"></app-content-detail>
</div>